import { render, staticRenderFns } from "./BudgetPreviewIncome.vue?vue&type=template&id=2b7b8304&scoped=true&"
import script from "./BudgetPreviewIncome.vue?vue&type=script&lang=ts&"
export * from "./BudgetPreviewIncome.vue?vue&type=script&lang=ts&"
import style0 from "./BudgetPreviewIncome.vue?vue&type=style&index=0&id=2b7b8304&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7b8304",
  null
  
)

export default component.exports